import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default props => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">
        Agent With Transaction
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          X:Y where, <br />
          X = Agent with sum of CICO above the TPV threshold for current month{' '}
          <br />
          Y = Agent with sum of CICO below the TPV threshold for current month{' '}
          <br /> <br />
          TPV threshold for current month = {props.summary.tpv_threshold}
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
